import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { IKeyAppointmentList } from '../interfaces/key-appointment-list.interface';

export class KeyAppointmentListModel extends BaseModel implements IKeyAppointmentList {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  code!: string;
}
